import { FontManager } from "@samuelmeuli/font-manager";

const EXCLUDED_FONTS = new Set([
  "Material Icons",
  "Material Icons Outlined",
  "Material Icons Round",
  "Material Icons Sharp",
  "Material Icons Two Tone",
  "Material Symbols Outlined",
  "Material Symbols Rounded",
  "Material Symbols Sharp",
  "Material Symbols Two Tone",
]);

const fontManager = new FontManager("AIzaSyBNXZCuWjCGIaPNSHkNkYbb3AGWoPPcI8M", "Roboto", {
  pickerId: "icastGoogleFontsPicker",
  limit: 250,
  filter: (font) => !EXCLUDED_FONTS.has(font.family),
});

const processFont = async (fontConfig) => {
  // 1. Create/select a dedicated element so FontManager doesn't overwrite it
  const customStyleId = `custom-font-${fontConfig.id}`;
  let customStyleEl = document.getElementById(customStyleId);

  if (!customStyleEl) {
    customStyleEl = document.createElement("style");
    customStyleEl.id = customStyleId;
    document.head.appendChild(customStyleEl);
  }

  const originalFontFamily = fontConfig.family;
  const encodedFamily = originalFontFamily.replace(/ /g, "+");

  try {
    const response = await fetch(`https://fonts.googleapis.com/css?family=${encodedFamily}&display=swap`);
    if (!response.ok) return;

    const cssText = await response.text();

    const newFontFamily = originalFontFamily.replace(/ /g, "");
    const newFontFamilyLower = originalFontFamily.toLowerCase();
    const newFontFamilyLowerNoSpaces = newFontFamilyLower.replace(/ /g, "");

    const fontAliases = Array.from(new Set([
      originalFontFamily,
      newFontFamily,
      newFontFamilyLower,
      newFontFamilyLowerNoSpaces
    ]));

    const escapedFontName = originalFontFamily.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    const fontFaceRegex = new RegExp(`@font-face\\s*\\{([^}]+font-family:\\s*['"]?${escapedFontName}['"]?;[^}]*)\\}`, 'gi');

    const updatedCssText = cssText.replace(fontFaceRegex, (match, innerCss) => {
      const templateWithoutFamily = innerCss.replace(/font-family:\s*['"]?[^';"]+['"]?;\s*/gi, '');

      return fontAliases
        .map(alias => `@font-face {\n  font-family: '${alias}';\n${templateWithoutFamily}}`)
        .join('\n');
    });

    // 2. Inject CSS safely into our own style element
    customStyleEl.innerHTML = updatedCssText;
  } catch (error) {
    console.error(`Failed to load style for ${originalFontFamily}:`, error);
  }
};

const processInBatches = async (items, batchSize, fn) => {
  for (let i = 0; i < items.length; i += batchSize) {
    const batch = items.slice(i, i + batchSize);
    await Promise.all(batch.map(fn));
  }
};

export const loadAndInitGoogleFontStyles = async () => {
  const fontList = await fontManager.getFonts();
  const fontArray = Array.from(fontList.values());

  const BATCH_SIZE = 10;
  await processInBatches(fontArray, BATCH_SIZE, processFont);
};

export const initGoogleFonts = () => {
  if (window.google?.fonts) {
    return;
  }

  fontManager
    .init()
    .then(() => {
      loadAndInitGoogleFontStyles();
    })
    .catch((error) => {
      console.error("Error initializing Google Fonts:", error);
    });

  window.google = {
    fonts: {
      load: () => {},
    },
  };
};
